module.exports = __webpack_public_path__ + "img/iconmap.996552f4.png";